import React, { useState } from 'react';
import Btn from '../common/Btn';
import ConfirmDialog from '../branches/ConfirmDialog';
import styles from './ReleaseIdentityStrip.module.css';
import { deleteReleaseWithAlert, setReleaseTagWithAlert } from './releaseActions';

const ICO_STAR  = 'm12 2 2.9 6.26L22 9.27l-5 4.87 1.18 6.86L12 17.77l-6.18 3.23L7 14.14 2 9.27l7.1-1.01L12 2z';
const ICO_TRASH = 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6';

const DELETE_ICON_STYLE = {
  background: 'var(--error-50)',
  border: '1px solid var(--error-200)',
  color: 'var(--error-700)',
};

export default function ActionsForReleaseDetail({ release, reloadData, navigate }) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleSetLatest = () => {
    setReleaseTagWithAlert(release.version, { is_latest: true }, {
      reloadData,
      successTitle: 'Latest release',
      successMessage: (r) => `${r.release.version} is now the latest release`,
      errorTitle: 'Set latest error',
    }).catch(() => {});
  };

  const handleDelete = () => {
    setDeleting(true);
    deleteReleaseWithAlert(release.version, {
      successTitle: 'Delete release',
      errorTitle: 'Delete error',
      onDeleted: () => navigate(`/branches/${release.branch_version}`),
    })
      .catch(() => {
        setDeleting(false);
        setConfirmOpen(false);
      });
  };

  return (
    <>
      <div className={styles.actions}>
        {release.status === 'released' && !release.is_latest && (
          <Btn variant="soft" size="lg" icon={ICO_STAR} onClick={handleSetLatest}>
            Set as latest release
          </Btn>
        )}
        {release.status === 'cancelled' && (
          <Btn variant="dangerOutline" size="lg" icon={ICO_TRASH} onClick={() => setConfirmOpen(true)}>
            Delete
          </Btn>
        )}
      </div>

      <ConfirmDialog
        open={confirmOpen}
        icon={ICO_TRASH}
        iconStyle={DELETE_ICON_STYLE}
        title="Delete release"
        message={`Are you sure you want to delete release "${release.version}"? This can't be undone.`}
        confirmLabel="Delete release"
        confirming={deleting}
        confirmingLabel="Deleting…"
        danger
        onConfirm={handleDelete}
        onCancel={() => setConfirmOpen(false)}
      />
    </>
  );
}
